import { render, staticRenderFns } from "./ActionSection.vue?vue&type=template&id=99edd2a0&scoped=true&"
import script from "./ActionSection.vue?vue&type=script&lang=js&"
export * from "./ActionSection.vue?vue&type=script&lang=js&"
import style0 from "./ActionSection.vue?vue&type=style&index=0&id=99edd2a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99edd2a0",
  null
  
)

export default component.exports